/** Tracks which OAuth provider a sign-in redirect was started with, so the
 *  /auth/callback route knows which callback endpoint to POST to. */

const KEY = 'ostrel-oauth-provider'

export interface PendingOAuth {
  id: string
  name: string
}

export function storePendingOAuth(pending: PendingOAuth): void {
  sessionStorage.setItem(KEY, JSON.stringify(pending))
}

/** Read and clear the pending provider (one-shot). */
export function takePendingOAuth(): PendingOAuth | null {
  const raw = sessionStorage.getItem(KEY)
  sessionStorage.removeItem(KEY)
  if (!raw) return null
  try {
    const parsed: unknown = JSON.parse(raw)
    if (
      parsed &&
      typeof parsed === 'object' &&
      typeof (parsed as PendingOAuth).id === 'string' &&
      typeof (parsed as PendingOAuth).name === 'string'
    ) {
      return parsed as PendingOAuth
    }
  } catch {
    /* malformed entry */
  }
  return null
}
